(function() {
    'use strict';

    angular
        .module('getwellApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('scheduler', {
            parent: 'app',
            url: '/calendar',
            data: {
                authorities: ['ROLE_PRACTICE']
            },
            views: {
                'content@': {
                    templateUrl: 'app/scheduler/scheduler.html',
                    controller: 'SchedulerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('scheduler');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
